import {findTimeZone} from '../helpers/dateTimeHelpers';
import {AppStore} from '../store/appStore';
import {updateDoNotDisturbAction} from '../store/data/preferences/preferencesActions';
import {getDoNotDisturb} from '../store/data/preferences/preferencesSelectors';
import {getIsUserVisitor} from '../store/data/teammates/teammatesSelectors';

export function setupTimezoneObserver(store: AppStore) {
  const initialState = store.getState();

  // Visitors don't have a timezone preference.
  if (getIsUserVisitor(initialState)) {
    return;
  }

  const fiveMinutes = 60 * 5 * 1000;
  let previousTimezone = getDoNotDisturb(initialState).timezone;

  const maybeUpdateTimezone = () => {
    const {getState, dispatch} = store;
    const doNotDisturb = getDoNotDisturb(getState());
    const doNotDisturbZone = previousTimezone;
    const currentZone = findTimeZone();

    // If the timezone hasn't changed, nothing to do.
    if (currentZone === doNotDisturbZone) {
      return;
    }

    // If the timezone changed, we update the preference.
    const action = updateDoNotDisturbAction({
      ...doNotDisturb,
      timezone: currentZone,
    });
    previousTimezone = currentZone;
    dispatch(action);
  };
  setInterval(maybeUpdateTimezone, fiveMinutes);

  // Run once after set-up.
  maybeUpdateTimezone();
}
